export function getLastDeploymentDate(env, expectedVersion, deployments) {
    if (!deployments) {
        return undefined;
    }
    const serverDeployment = deployments.find((d) => d.env === env);
    if (serverDeployment &&
        serverDeployment.deployment &&
        serverDeployment.deployment.version === expectedVersion) {
        return serverDeployment.deployment.depl_time ?? undefined;
    }
    return undefined;
}
